'use strict';

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _storage = require('shared/redux/middlewares/storage');

var _createStore = require('shared/redux/createStore');

var _createStore2 = _interopRequireDefault(_createStore);

var _routes = require('shared/routes');

var _routes2 = _interopRequireDefault(_routes);

var _renderIntoDOM = require('./renderIntoDOM.jsx');

var _renderIntoDOM2 = _interopRequireDefault(_renderIntoDOM);

var _getReduxAsyncComponent = require('shared/redux/utils/getReduxAsyncComponent.jsx');

var _getReduxAsyncComponent2 = _interopRequireDefault(_getReduxAsyncComponent);

var _checkIfValidPayload = require('./checkIfValidPayload');

var _checkIfValidPayload2 = _interopRequireDefault(_checkIfValidPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _createStore2.default)(_reactRouter.browserHistory, (0, _storage.mergeStates)((0, _storage.getStorage)(), window.__data));
//import useScroll from 'scroll-behavior/lib/useStandardScroll';

var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store, {
  adjustUrlOnReplay: false
});

var component = _react2.default.createElement(
  _reactRouter.Router,
  {
    render: function render(props) {
      return (0, _getReduxAsyncComponent2.default)(props, {}, function (item) {
        return !item.deferred;
      });
    },
    history: history
  },
  (0, _routes2.default)(store)
);

var dest = document.getElementById('content');

// check to make sure the server payload was not discarded.
(0, _checkIfValidPayload2.default)(dest);

(0, _renderIntoDOM2.default)(component, store, dest);


//////////////////
// WEBPACK FOOTER
// ./src/browser/index.js
// module id = 1065
// module chunks = 0